import store from "../store";

export default [
  {
    path: "/admin/auth",
    name: "adminAuth",
    component: () => import("../pages/admin/Auth")
  },
  {
    path: "/admin/login",
    name: "adminLogin",
    component: () => import("../pages/admin/Login")
  },
  {
    path: "/admin",
    beforeEnter(to, from, next) {
      const isBeginning = store.getters["loginUser/isBeginning"];
      if (isBeginning) {
        next({
          name: "adminAuth",
          query: {
            returnurl: to.fullPath
          }
        });
        return;
      } else {
        const user = store.state.loginUser.user;
        if (!user) {
          next({
            name: "adminLogin",
            query: {
              returnurl: to.fullPath
            }
          });
          return;
        }
      }
      next();
    },
    component: () => import("../pages/admin/Layout"),
    children: [
      {
        path: "article",
        component: () => import("../pages/admin/article/Layout"),
        meta: {
          menuName: "文章管理",
          menuIcon: "el-icon-document",
          menuOrder: 2,
          show: true
        },
        children: [
          {
            path: "add",
            name: "adminArticleAdd",
            component: () => import("../pages/admin/article/Add"),
            meta: {
              menuName: "添加文章",
              menuOrder: 2,
              show: true
            }
          },
          {
            path: "/",
            name: "adminArticleList",
            component: () => import("../pages/admin/article/List"),
            meta: {
              menuName: "文章列表",
              menuOrder: 1,
              show: true
            }
          },
          {
            path: "edit/:id",
            name: "adminArticleEdit",
            component: () => import("../pages/admin/article/Edit"),
            meta: {
              menuName: "修改文章"
            }
          }
        ]
      },
      {
        path: "articletype",
        component: () => import("../pages/admin/type/Layout"),
        meta: {
          menuName: "分类管理",
          menuIcon: "el-icon-copy-document",
          menuOrder: 3,
          show: true
        },
        children: [
          {
            path: "add",
            name: "adminArticleTypeAdd",
            component: () => import("../pages/admin/type/Add"),
            meta: {
              menuName: "添加分类",
              menuOrder: 2,
              show: true
            }
          },
          {
            path: "edit/:id",
            name: "adminArticleTypeEdit",
            component: () => import("../pages/admin/type/Edit"),
            meta: {
              menuName: "修改分类"
            }
          },
          {
            path: "/",
            name: "adminArticleTypeList",
            component: () => import("../pages/admin/type/List"),
            meta: {
              menuName: "分类列表",
              menuOrder: 1,
              show: true
            }
          }
        ]
      },
      {
        path: "system",
        component: () => import("../pages/admin/system/Layout"),
        meta: {
          menuName: "系统设置",
          menuIcon: "el-icon-s-tools",
          menuOrder: 4,
          show: true
        },
        children: [
          {
            path: "updateSystem",
            name: "adminUpdateSystem",
            component: () => import("../pages/admin/system/UpdateSystem"),
            meta: {
              menuName: "全局设置",
              menuOrder: 1,
              show: true
            }
          },
          {
            path: "friends",
            name: "adminUpdateFriends",
            component: () => import("../pages/admin/system/FriendLinks"),
            meta: {
              menuName: "友情链接",
              menuOrder: 2,
              show: true
            }
          },
          {
            path: "userinfo",
            name: "adminUpdateUserInfo",
            component: () => import("../pages/admin/system/UserInfo"),
            meta: {
              menuName: "博主信息",
              menuOrder: 3,
              show: true
            }
          },
          {
            path: "pwd",
            name: "adminUpdatePassword",
            component: () => import("../pages/admin/system/UpdatePassword"),
            meta: {
              menuName: "修改密码",
              menuOrder: 4,
              show: true
            }
          }
        ]
      },
      {
        path: "/",
        name: "adminHome",
        component: () => import("../pages/admin/Home"),
        meta: {
          menuName: "管理首页",
          show: true,
          menuIcon: "el-icon-s-management",
          menuOrder: 1
        }
      }
    ]
  }
];
